
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ConfirmEmail extends Vue {
  private colors = {
    lightGray: '#b4b4c4',
    darkPurple: '#36134a',
  };

  private name = '';

  private items: Array<string> = [
    'Saleforce',
    'Shopify',
  ]

  private submit(): void {
    this.$emit('closed');
  }
}
